module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isBordered),
      callback: function($$v) {
        _vm.isBordered = $$v
      },
      expression: "isBordered"
    }
  }, [_vm._v("Bordered")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isStriped),
      callback: function($$v) {
        _vm.isStriped = $$v
      },
      expression: "isStriped"
    }
  }, [_vm._v("Striped")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isNarrowed),
      callback: function($$v) {
        _vm.isNarrowed = $$v
      },
      expression: "isNarrowed"
    }
  }, [_vm._v("Narrowed")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isHoverable),
      callback: function($$v) {
        _vm.isHoverable = $$v
      },
      expression: "isHoverable"
    }
  }, [_vm._v("Hoverable")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isFocusable),
      callback: function($$v) {
        _vm.isFocusable = $$v
      },
      expression: "isFocusable"
    }
  }, [_vm._v("Focusable")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_vm._v("Loading state")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isEmpty),
      callback: function($$v) {
        _vm.isEmpty = $$v
      },
      expression: "isEmpty"
    }
  }, [_vm._v("Empty")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.hasMobileCards),
      callback: function($$v) {
        _vm.hasMobileCards = $$v
      },
      expression: "hasMobileCards"
    }
  }, [_vm._v("Mobile cards "), _c('small', [_vm._v("(collapsed rows)")])])], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "data": _vm.isEmpty ? [] : _vm.data,
      "bordered": _vm.isBordered,
      "striped": _vm.isStriped,
      "narrowed": _vm.isNarrowed,
      "hoverable": _vm.isHoverable,
      "loading": _vm.isLoading,
      "focusable": _vm.isFocusable,
      "mobile-cards": _vm.hasMobileCards
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "id",
            "label": "ID",
            "width": "40",
            "numeric": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.id) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "first_name",
            "label": "First Name"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.first_name) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "last_name",
            "label": "Last Name"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.last_name) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "date",
            "label": "Date",
            "centered": ""
          }
        }, [_c('span', {
          staticClass: "tag is-success"
        }, [_vm._v("\n                        " + _vm._s(new Date(props.row.date).toLocaleDateString()) + "\n                    ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Gender"
          }
        }, [_c('span', [_c('b-icon', {
          attrs: {
            "pack": "fas",
            "icon": props.row.gender === 'Male' ? 'mars' : 'venus'
          }
        }), _vm._v("\n                        " + _vm._s(props.row.gender) + "\n                    ")], 1)])]
      }
    }])
  }, [_c('template', {
    slot: "empty"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "content has-text-grey has-text-centered"
  }, [_c('p', [_c('b-icon', {
    attrs: {
      "icon": "emoticon-sad",
      "size": "is-large"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("Nothing here.")])])])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c0d24e1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/table/examples/ExSandbox.vue
// module id = 1201
// module chunks = 1 86